import { useContext } from "react";

import UnitNavPart from "./UnitNavPart";
import clsx from "clsx";
import { UnitContext } from "../../contexts/contextExporter";
import { IUnitNavMl } from "../../types/unitTypes";

export default function UnitNavMl({
  ml,
  isActive,
  order,
}: {
  ml: IUnitNavMl;
  isActive: boolean;
  order: number;
}) {
  const { pin, setPinWithEmit, canNavigate, currentMlParts, arePartsLoading } =
    useContext(UnitContext);

  const handleMlClick = () => {
    if (canNavigate) {
      setPinWithEmit({
        mlOrder: order,
        partMode: ml.ml_id === -1 || ml.is_zoom ? "ZOOM" : "VIDEO",
        partOrder: 0,
      });
    }
  };

  return (
    <div>
      <div
        onClick={handleMlClick}
        className={clsx(
          "text-sm px-3 py-2.5 rounded-xl transition-colors",
          isActive
            ? "bg-white/[0.08] text-white font-semibold"
            : "text-white/60 font-medium",
          !isActive && canNavigate && "cursor-pointer hover:text-white/70 hover:bg-white/5"
        )}
      >
        {ml.ml_title}
      </div>
      {isActive && ml.ml_id > 0 && (
        <div className="mt-1 mb-1 ml-3 text-sm">
          {arePartsLoading
            ? <span className="text-white/30 text-xs px-3 py-1">yükleniyor...</span>
            : currentMlParts?.map((part, partOrder) => (
              <UnitNavPart
                key={part.id}
                part={part}
                partOrder={partOrder}
                isPartActive={pin?.partOrder === partOrder}
              />
            ))}
        </div>
      )}
    </div>
  );
}
